import logo from "../../assets/images/HMS-Logo 1.png"

export default function PrintHeader() {
  return (
    <div>
      {" "}
      <div className="text-center">
        <img src={logo} alt="logo" width={100} />
      </div>
      <div className="text-center d-flex flex-column gap-1 align-items-center">
        <h4 className="fw-bold text-danger">BIAKA HOSPITAL</h4>
        <h5 className="text-success">BOKOKO-BUEA</h5>
        <div className="d-flex  gap-5">
          <p>Email:biakahospital@biakahc.org</p>
          <p>Phone: (+237) 233 322 558 / 698 625 760</p>
        </div>
      </div>
	  <hr />
    </div>
  );
}
